import { useV1MarketplaceStoresList } from "@/api/generated/v1/v1";
import type { Store } from "@/api/generated/models";
import { PageBanner } from "@/shared/components/PageBanner";
import { Link } from "react-router-dom";

export function StoreListPage() {
  const { data, isLoading, isError } = useV1MarketplaceStoresList();
  const stores = data?.results ?? [];

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="فروشگاه‌ها"
        subtitle="مدیریت و مشاهده فروشگاه‌های ثبت‌شده در بازار"
        icon="🏪"
        helpLink="/help/marketplace/stores"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <Link
            to="/marketplace/stores/new"
            style={{
              padding: "0.6rem 1.25rem",
              borderRadius: "12px",
              background: "#ffffff",
              color: "#007270",
              fontWeight: 700,
              fontSize: "0.9rem",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              transition: "all 0.2s ease",
              textDecoration: "none"
            }}
          >
            <span>➕</span>
            <span>ایجاد فروشگاه</span>
          </Link>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        {isLoading && <p>در حال بارگذاری...</p>}
        {isError && <p style={{ color: "red" }}>خطا در دریافت فروشگاه‌ها.</p>}

        {!isLoading && !isError && (
          <div className="table-container" style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", textAlign: "right", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid var(--glass-border)" }}>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>شناسه</th>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>وضعیت</th>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>کد فروشنده</th>
                </tr>
              </thead>
              <tbody>
                {stores.length === 0 && (
                  <tr>
                    <td colSpan={3} style={{ padding: "2rem", textAlign: "center", color: "var(--color-text-muted)" }}>
                      هیچ فروشگاهی یافت نشد.
                    </td>
                  </tr>
                )}
                {stores.map((store: Store) => (
                  <tr key={store.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                    <td style={{ padding: "1rem", fontFamily: "monospace" }}>{store.id}</td>
                    <td style={{ padding: "1rem" }}>
                      <span style={{
                        padding: "4px 12px",
                        borderRadius: "999px",
                        fontSize: "0.85rem",
                        fontWeight: "bold",
                        backgroundColor: store.is_active ? "rgba(59, 122, 114, 0.1)" : "rgba(179, 66, 58, 0.1)",
                        color: store.is_active ? "var(--color-success)" : "var(--color-error)",
                        border: `1px solid ${store.is_active ? "var(--color-success)" : "var(--color-error)"}`
                      }}>
                        {store.is_active ? "فعال" : "غیرفعال"}
                      </span>
                    </td>
                    <td style={{ padding: "1rem" }}>{store.seller_organization_id || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
